<template>
  <div class="mistake">
    <a-result status="500" title="500" sub-title="非常抱歉，系统貌似出了点小问题">
      <template #extra>
        <a-button type="primary" @click="returnPage">回到首页</a-button>
      </template>
    </a-result>
  </div>
</template>

<script>
  export default {
    name: 'Mistake',
    methods: {
      returnPage() {
        this.$store.commit('setRedirectUrl', null);
        this.$router.replace('/');
      }
    },
  }
</script>

<style lang="less" scoped>

</style>